import React from "react";
import SetupCard from "src/pages/GetStarted/Onboarding/SetupCard";
import viewingDataIcon from "src/assets/onboarding/addYourData.svg";
import { useSelector } from "react-redux";
import { getAllSales } from "src/store/sale/selector";
import { completeUserSetupQuestionCardManualUpload } from "src/apiService/modules/users";

const ManualUploadCard = ({
  onClick,
  completed = false,
  platforms = [],
  skipDataGate = false,
}: {
  onClick: () => void;
  completed?: boolean;
  platforms?: string[];
  skipDataGate?: boolean;
}) => {
  const sales = useSelector(getAllSales);
  const disabled = !skipDataGate && !sales.length;
  const formatPlatformList = (values: string[]) => {
    if (values.length === 0) return "";
    if (values.length === 1) return values[0];
    if (values.length === 2) return `${values[0]} and ${values[1]}`;
    return `${values.slice(0, -1).join(", ")}, and ${
      values[values.length - 1]
    }`;
  };
  const uniquePlatforms = Array.from(
    new Set(platforms.map((platform) => platform.trim()).filter(Boolean))
  );
  const platformSummary =
    uniquePlatforms.length === 0 ? null : formatPlatformList(uniquePlatforms);
  const description = platformSummary
    ? `Learn how to manually enter or bulk-upload your sales, inventory, and expenses for ${platformSummary}.`
    : "Learn how to manually enter or bulk-upload your sales, inventory, and expenses.";

  return (
    <SetupCard
      title="Add Your Data"
      imageSrc={viewingDataIcon}
      description={description}
      buttonText="Show Me How"
      onButtonClick={onClick}
      points={15}
      disabled={disabled}
      tooltipText={
        disabled
          ? "Connect an account and import data to complete this step."
          : undefined
      }
      completed={completed}
      onManualComplete={() =>
        completeUserSetupQuestionCardManualUpload({ source: "user-dismissed" })
      }
    />
  );
};

export default ManualUploadCard;
